var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55730_3695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2009 30.7001C30.0636 30.7001 30.918 30.5301 31.7151 30.1999C32.5122 29.8698 33.2365 29.3858 33.8466 28.7758C34.4566 28.1657 34.9406 27.4414 35.2707 26.6443C35.6009 25.8472 35.7709 24.9928 35.7709 24.1301C35.7709 23.2673 35.6009 22.4129 35.2707 21.6158C34.9406 20.8187 34.4566 20.0944 33.8466 19.4844C33.2365 18.8743 32.5122 18.3903 31.7151 18.0602C30.918 17.73 30.0636 17.5601 29.2009 17.5601C27.4584 17.5601 25.7873 18.2523 24.5552 19.4844C23.3231 20.7165 22.6309 22.3876 22.6309 24.1301C22.6309 25.8725 23.3231 27.5436 24.5552 28.7758C25.7873 30.0079 27.4584 30.7001 29.2009 30.7001V30.7001Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0395 61.36C62.0395 63.6833 61.1166 65.9115 59.4737 67.5543C57.8309 69.1971 55.6028 70.12 53.2795 70.12H18.2395C15.9162 70.12 13.6881 69.1971 12.0452 67.5543C10.4024 65.9115 9.47949 63.6833 9.47949 61.36V8.80004C9.47949 6.47674 10.4024 4.2486 12.0452 2.60578C13.6881 0.962965 15.9162 0.0400391 18.2395 0.0400391L42.3295 0.0400391L62.0395 19.75V61.36ZM18.2395 4.42004C17.0778 4.42004 15.9638 4.8815 15.1424 5.70291C14.321 6.52432 13.8595 7.63839 13.8595 8.80004V52.6L23.6006 42.8589C23.9458 42.5145 24.3961 42.2952 24.8801 42.2357C25.3641 42.1762 25.8541 42.2799 26.2724 42.5304L35.7595 48.22L45.2071 34.9924C45.392 34.7339 45.6309 34.5187 45.9073 34.3618C46.1837 34.2049 46.4909 34.11 46.8077 34.0837C47.1244 34.0575 47.4431 34.1005 47.7415 34.2097C48.04 34.319 48.311 34.4919 48.5359 34.7165L57.6595 43.84V19.75H48.8995C47.157 19.75 45.4859 19.0578 44.2538 17.8257C43.0217 16.5936 42.3295 14.9225 42.3295 13.18V4.42004H18.2395Z",
    fill: "#484848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55730_3695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.08,
    height: 70.08,
    fill: "white",
    transform: "translate(0.719727 0.0400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4960267db6d888fd6d5cd89987e2d3d0.svg";
export { ForwardRef as ReactComponent };